import type { AuthServiceInterface, GetAuthTokenModel } from '@acme/domains';
import { getAuthSecretAdmin, getAuthTokenAdmin } from '@acme/domains';
import { DigitalSignatureLogin } from '@acme/features';
import { useAuthWithRedirect } from '@shared/lib/useAuth';

const authService: AuthServiceInterface = {
  getAuthSecret: getAuthSecretAdmin,
  getAuthToken: getAuthTokenAdmin as GetAuthTokenModel,
};

const EcpLoginPage = () => {
  const { auth, loading, error } = useAuthWithRedirect({
    authService,
  });

  return (
    <DigitalSignatureLogin
      onAuth={auth}
      loading={loading}
      error={error}
      supportsRoleSelection={false}
    />
  );
};

export { EcpLoginPage };
